import React from 'react';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  image: {
    maxHeight: 80,
    [theme.breakpoints.down('md')]: {
      maxHeight: 47
    }
  }
}));

export default function Logo({...rest}) {
  const classes = useStyles();
  return <img src={'/img/cw_logo.svg'} className={classes.image} />;
}



// WEBPACK FOOTER //
// ./src/shared/components/Logo.js